import { FlowScope, parseFlowScope } from "./flowScope";

/** Default post-login route for Light Hosted Application. */
export const STANDALONE_DEFAULT_ROUTE = "/dash";

/**
 * Canonical entry paths after login for each flow scope.
 * Shared by Embedded Flow and Light Hosted Application.
 */
export const FLOW_SCOPE_ENTRY_PATHS: Partial<Record<FlowScope, string>> = {
  [FlowScope.Enrollment]: "/enroll",
  [FlowScope.Billing]: "/dash/billing",
  [FlowScope.Documents]: "/account/documents",
  [FlowScope.UpdatePaymentMethod]: "/account/payment-method/update",
  [FlowScope.Renewal]: "/renew/intro",
};

export function flowScopeEntryPath(scope: FlowScope): string | undefined {
  return FLOW_SCOPE_ENTRY_PATHS[scope];
}

export function requiredFlowScopeEntryPath(scope: FlowScope): string {
  const path = FLOW_SCOPE_ENTRY_PATHS[scope];
  if (path === undefined) {
    throw new Error(`Missing entry path for scope: ${scope}`);
  }

  return path;
}

export function standaloneLoginRoute(
  scope: FlowScope | string | null | undefined,
): string {
  const parsedScope =
    typeof scope === "string" || scope === null || scope === undefined
      ? parseFlowScope(scope)
      : scope;

  if (parsedScope === null) {
    return STANDALONE_DEFAULT_ROUTE;
  }

  return FLOW_SCOPE_ENTRY_PATHS[parsedScope] ?? STANDALONE_DEFAULT_ROUTE;
}
